<template>
  <div class="my-2 cursor-pointer">
    <NBox class="px-2 py-1.5 text-right">
      <div>
        <NText variant="caption2" weight="medium">
          {{ news.messageTitle }}
        </NText>
      </div>
      <template
        v-for="(tag, index) of tagsToRender"
        :key="`${tag.isin}${index}`"
      >
        <div class="inline-flex mt-2 items-center ml-1">
          <NCheap
            :label="tag.eighteenCharacterInstrumentNameOfAfcNorm"
            :closable="false"
            size="small"
            @click.stop="updateActiveIsin(tag.isin)"
          />
        </div>
      </template>

      <div
        v-if="news.tags && news.tags.length > MAX_TAGS_TO_SHOW"
        class="inline-flex mt-2 items-center ml-1"
      >
        <NCheap
          :label="`+ ${news.tags.length - MAX_TAGS_TO_SHOW}`"
          :closable="false"
          dir="ltr"
          size="small"
        />
      </div>
    </NBox>

    <div class="flex justify-end px-2 text-neutral-secondary mt-0.5">
      <NText variant="overline" class="align-middle">
        {{ newsTime }}
      </NText>
    </div>
  </div>
</template>

<script setup lang="ts">
import { NewsItem } from '@libs/api-reference';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

import { useActiveSymbolIsin } from '@/modules/symbol';

const MAX_TAGS_TO_SHOW = 4;

const props = defineProps<{ news: NewsItem }>();

const { d } = useI18n();

const { updateActiveIsin } = useActiveSymbolIsin();

const tagsToRender = computed(() => {
  if (props.news.tags) {
    if (props.news.tags.length > MAX_TAGS_TO_SHOW) {
      return props.news.tags.slice(0, MAX_TAGS_TO_SHOW);
    }

    return props.news.tags;
  }

  return [];
});

const newsTime = computed(() => {
  const newsDate = props.news.date;

  if (newsDate) {
    return `${d(newsDate, 'shortTime')} ، ${d(newsDate, 'shortDate')}`;
  }

  return '';
});
</script>
